export const DISMISS_CURATION = 'dismiss-curation';
export const DISMISS_CURATION_COOKIE_NAME = 'pw-curation-dismissed';
const dismissCuration = () => ({ type: DISMISS_CURATION });
export default dismissCuration;
